import { FETCH_DELETE_SUMMARY_START, FETCH_DELETE_SUMMARY_SUCCESS, FETCH_DELETE_SUMMARY_FAILED } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_DELETE_SUMMARY_FAILED:
    case FETCH_DELETE_SUMMARY_START:
      return {
        resources: {
          bundleUsages: null,
          licenseBundleUsages: null,
          bundles: null,
          licenseBundles: null,
          customers: null,
          invoices: null,
          productBundles: null,
          productLicenseBundles: null,
          products: null,
          productMetadataTypes: null,
          productGroups: null,
          productGroupings: null,
          purchases: null,
          outOfBundlePurchases: null,
          templates: null
        }
      };
    case FETCH_DELETE_SUMMARY_SUCCESS:
      const { payload } = action;
      return {
        resources: {
          bundleUsages: payload.bundleUsages,
          licenseBundleUsages: payload.licenseBundleUsages,
          bundles: payload.bundles,
          licenseBundles: payload.licenseBundles,
          customers: payload.customers,
          customerGroups: payload.customerGroups,
          invoices: payload.invoices,
          productBundles: payload.productBundles,
          productLicenseBundles: payload.productLicenseBundles,
          products: payload.products,
          productMetadataTypes: payload.productMetadataTypes,
          productGroups: payload.productGroups,
          productGroupings: payload.productGroupings,
          purchases: payload.purchases,
          outOfBundlePurchases: payload.outOfBundlePurchases,
          templates: payload.templates,
          discounts: payload.discounts
        }
      };
    default:
      return state;
  }
};
